
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import { objectWithoutProperties as _objectWithoutProperties, defineProperty as _defineProperty, extends as _extends } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import { forwardRef } from 'react';
import classNames from '../../../../node_modules/classnames/index.js';
import Label from '../Label/Label.js';
import { textareaContainer } from './styles.js';
import { createElement as jsx } from '../../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var _excluded = ["label", "required", "inline", "id", "resize", "status", "containerAttrs", "rows"];
var Textarea = function Textarea(props, forwardedRef) {
  var _containerAttrs$class;
  var label = props.label,
    _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required,
    _props$inline = props.inline,
    inline = _props$inline === void 0 ? false : _props$inline,
    id = props.id,
    _props$resize = props.resize,
    resize = _props$resize === void 0 ? "none" : _props$resize,
    _props$status = props.status,
    status = _props$status === void 0 ? "valid" : _props$status,
    containerAttrs = props.containerAttrs,
    rows = props.rows,
    rest = _objectWithoutProperties(props, _excluded);
  var hasLabel = Boolean(label);
  var containerClassNames = classNames(_defineProperty({
    inline: hasLabel && inline,
    valid: status === "valid",
    error: status === "error"
  }, (_containerAttrs$class = containerAttrs === null || containerAttrs === void 0 ? void 0 : containerAttrs.className) !== null && _containerAttrs$class !== void 0 ? _containerAttrs$class : "", Boolean(containerAttrs === null || containerAttrs === void 0 ? void 0 : containerAttrs.className)));
  var labelClassNames = classNames({
    required: required
  });
  var hasRows = !!rows && rows > 0;
  return jsx("div", _extends({
    css: function css(theme) {
      return textareaContainer(theme, {
        resize: resize,
        hasRows: hasRows
      });
    }
  }, containerAttrs, {
    className: containerClassNames
  }), hasLabel && jsx(Label, {
    htmlFor: id,
    className: labelClassNames,
    "data-testid": "textarea-label-".concat(id)
  }, label), jsx("textarea", _extends({
    id: id,
    ref: forwardedRef,
    rows: rows
  }, rest)));
};
var Textarea$1 = /*#__PURE__*/forwardRef(Textarea);

export { Textarea$1 as default };
//# sourceMappingURL=Textarea.js.map
